import api from "./axios"; // axios déjà configuré avec baseURL


// Tous les appels utilisent maintenant api (baseURL = REACT_APP_API_URL)
export const getTechniciens = () => api.get("/technicien");
export const getTechnicienById = (id) => api.get(`/technicien/${id}`);

export const createTechnicien = async (data) => {
  try {
    const res = await api.post("/technicien", data);
    console.log("Technicien créé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
  }
};

export const updateTechnicien = async (id, data) => {
  try {
    const res = await api.put(`/technicien/${id}`, data);
    console.log("Technicien mis à jour :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la mise à jour :", ex.response ? ex.response.data : ex);
  }
};

export const deleteTechnicien = async (id) => {
  try {
    const res = await api.delete(`/technicien/${id}`);
    console.log("Technicien supprimé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la suppression :", ex.response ? ex.response.data : ex);
  }
};

export const getStatsTechnicien = () => api.get("/stats");

// Pour les endpoints avec headers (auth JWT)
export const getRendezVousTechnicien = (filters = {}) =>
  api.get("/technicien/rendez-vous", {
    params: filters,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

export const getRendezVousAujourdhui = () =>
  api.get("/technicien/rendez-vous/aujourdhui", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
